<template>
	<div id="topo">
		<span class="titulo_paginas">{{title}}</span>
		<hr>
	</div>
</template>

<script>
export default {
	props: ['title'],
}
</script>

<style scoped>

#topo {
	position: relative;
	top: 20px;
	right: 0px;
	left: 0px;
	font-size: 13px;
	height: 40px;
	max-width: 960px;
	margin: auto;
}

.titulo_paginas {
	background-color: #253b6d;
	color: #ffffff;
	left: 10px;
	line-height: 0;
	position: absolute;
	top: 0px;
	padding: 10px;
}

#topo hr {
	width: 100%;
	border-top: 0;
	border-left: 0;
	border-right: 0;
	border-bottom: 1px solid #253b6d;
	position: absolute;
	margin: 0px;
	top: 19px;
	z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/PageTitle.vue